import React from 'react';
import styled from 'styled-components';

import { Colors } from '../../theme';
import config from '../../config';

const Container = styled.div`
  display: inline-block;
  text-align: center;

  ${props => {
    switch (props.size) {
      case 'large': return `
        margin-bottom: 5rem;
        width: 18rem;
        img {
           max-width: 18rem;
        }
      `;
      case 'regular': return `
        margin-bottom: 1rem;
        width: 12rem;
        img {
          max-width: 12rem;
        }
      `;
      case 'small': return `
        margin-bottom: .5rem;
        width: 8rem;
        img {
          max-width: 8rem;
        }
      `;
    }
  }}
`;

const Slogan = styled.h2`
  background: ${Colors.gradients.brand};
  background-clip: text;
  font-weight: 300;
  -webkit-text-fill-color: transparent;
  color: ${props => props.type === 'light'
? Colors.typography.inverted
    : props.type === 'dark' ? Colors.lighten(Colors.typography.primary, 40) : 'inherit'};
  ${props => {
    if (props.type === 'light' || props.type === 'dark') {
      return `
        background: none;
        background-clip: initial;
        -webkit-text-fill-color: initial;
      `;
    }
  }}
  ${props => {
    switch (props.size) {
      case 'large': return `
        font-size: 1.25rem;
      `;
      case 'regular': return `
        font-size: .8rem;
      `;
      case 'small': return `
        font-size: .55rem;
      `;
    }
  }}
`;

const Logo = ({
  type,
  className,
  logoStyle,
  slogan = '',
  size = 'regular',
  style
}) => {
  return (
    <Container className={className} size={size} style={style}>
      <img src={config.logoUrl} style={logoStyle} />
      {slogan && <Slogan size={size} type={type}>{slogan}</Slogan>}
    </Container>
  );
};

export default Logo;
